import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class VideoConverter {

  constructor(private sanitizer: DomSanitizer) {}

  public getSafeEmbedUrl(url: string | null | undefined): SafeResourceUrl | null {
    if (!url) return null;

    const embedUrl = this.convertToEmbedUrl(url);

    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  private convertToEmbedUrl(url: string): string {
    try {
      const parsed = new URL(url);

      if (parsed.hostname.includes('youtube.com')) {

        if (parsed.pathname.includes('/embed/')) {
          return url;
        }

        const videoId = parsed.searchParams.get('v');
        if (videoId) {
          return `https://www.youtube.com/embed/${videoId}`;
        }
      }

      if (parsed.hostname.includes('youtu.be')) {
        const videoId = parsed.pathname.slice(1);
        return `https://www.youtube.com/embed/${videoId}`;
      }

      if (parsed.hostname.includes('rutube.ru')) {

        if (parsed.pathname.includes('/play/embed/')) {
          return url;
        }

        const parts = parsed.pathname.split('/');
        const videoId = parts.pop();

        return `https://rutube.ru/play/embed/${videoId}`;
      }

      if (
        parsed.hostname.includes('vk.com') ||
        parsed.hostname.includes('vkvideo.ru')
      ) {
        const match = parsed.pathname.match(/video(-?\d+)_(\d+)/);

        if (match) {
          const ownerId = match[1];
          const videoId = match[2];

          return `https://vkvideo.ru/video_ext.php?oid=${ownerId}&id=${videoId}`;
        }
      }

      return url;

    } catch {
      return url;
    }
  }
}
